// const apiUrl ='http://192.168.0.199:8081/api/v1'

const apiUrl = "https://apivibrantpropmart.abilioit.com/api/v1"

export default apiUrl